function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cml-1{fill:#ffffff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M78,116.39H74v3.44h2.91v1.9H74v4.06H78v1.9H72v-13.2h6Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M85.15,118.15c-.32-1.31-.9-2-1.74-2a1.25,1.25,0,0,0-1,.39,1.34,1.34,0,0,0-.38,1,2,2,0,0,0,.55,1.33l.21.23a1.56,1.56,0,0,0,.26.23l.45.36.83.62.71.58c.2.16.37.31.51.44l.4.39a3,3,0,0,1,.33.38,3.79,3.79,0,0,1,.85,2.41,3.21,3.21,0,0,1-1,2.43,3.47,3.47,0,0,1-1.14.7,4.29,4.29,0,0,1-1.48.24q-3.37,0-4-3.7l2-.57c.25,1.58.93,2.37,2,2.37a1.45,1.45,0,0,0,1.09-.41,1.47,1.47,0,0,0,.42-1.09,1.87,1.87,0,0,0-.09-.59,2.19,2.19,0,0,0-.32-.56,4.87,4.87,0,0,0-.6-.64c-.25-.22-.57-.48-1-.79L82,121.05c-.26-.21-.47-.39-.62-.53a4.54,4.54,0,0,1-.38-.37c-.1-.11-.2-.25-.32-.41a3.48,3.48,0,0,1-.74-2.2,3.33,3.33,0,0,1,.26-1.31,3.22,3.22,0,0,1,.71-1,3.27,3.27,0,0,1,1.09-.67,3.86,3.86,0,0,1,1.39-.24q2.85,0,3.7,3.29Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M93.53,127.69h-2v-11.3H88.93v-1.9h7.18v1.9H93.53Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M98,114.49h3.23a3.77,3.77,0,0,1,2.89,1,4.48,4.48,0,0,1,.93,3.12v4.93a4.52,4.52,0,0,1-.93,3.13,3.77,3.77,0,0,1-2.89,1H98Zm3.06,11.3a1.69,1.69,0,0,0,1.5-.63A4,4,0,0,0,103,123v-3.8a4,4,0,0,0-.43-2.18,1.71,1.71,0,0,0-1.5-.62h-1v9.4Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M109.44,127.69h-1.92v-2.12h1.92Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M304.93,127.69H303V117.6h-1.9v-1.21a7.57,7.57,0,0,0,.8-.41,8.36,8.36,0,0,0,.77-.48c.23-.17.45-.34.65-.52a2.64,2.64,0,0,0,.47-.49h1.13Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M310.77,124.26v.32c0,1,.41,1.48,1.22,1.48a1.35,1.35,0,0,0,.67-.16.92.92,0,0,0,.42-.45,2.32,2.32,0,0,0,.22-.78,12,12,0,0,0,.06-1.4v-1.64a2.86,2.86,0,0,1-.89.81,2.36,2.36,0,0,1-1.11.24,2.26,2.26,0,0,1-2-1,5.54,5.54,0,0,1-.65-3q0-4.41,3.3-4.41a2.87,2.87,0,0,1,2.44,1.11,3.78,3.78,0,0,1,.65,1.42,9.46,9.46,0,0,1,.2,2.1v4.71a7.7,7.7,0,0,1-.19,1.84,3.92,3.92,0,0,1-.6,1.27,3,3,0,0,1-1.08.85,3.53,3.53,0,0,1-1.44.29,3,3,0,0,1-2.27-.89,3.31,3.31,0,0,1-.85-2.41v-.32Zm2.59-6c0-1.43-.45-2.14-1.35-2.14a1.09,1.09,0,0,0-1,.57,4.23,4.23,0,0,0-.3,1.87,4,4,0,0,0,.29,1.78,1.08,1.08,0,0,0,1,.53,1.44,1.44,0,0,0,.73-.18,2.68,2.68,0,0,0,.66-.63Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M320.06,124.26v.32c0,1,.41,1.48,1.23,1.48a1.29,1.29,0,0,0,.66-.16.94.94,0,0,0,.43-.45,2.58,2.58,0,0,0,.22-.78,12,12,0,0,0,.06-1.4v-1.64a2.86,2.86,0,0,1-.89.81,2.39,2.39,0,0,1-1.11.24,2.25,2.25,0,0,1-2-1,5.45,5.45,0,0,1-.65-3q0-4.41,3.3-4.41a2.84,2.84,0,0,1,2.43,1.11,3.8,3.8,0,0,1,.66,1.42,9.52,9.52,0,0,1,.19,2.1v4.71a7.76,7.76,0,0,1-.18,1.84,3.74,3.74,0,0,1-.61,1.27,3.06,3.06,0,0,1-1.07.85,3.53,3.53,0,0,1-1.44.29A3,3,0,0,1,319,127a3.31,3.31,0,0,1-.85-2.41v-.32Zm2.6-6c0-1.43-.45-2.14-1.35-2.14a1.09,1.09,0,0,0-1,.57,4.23,4.23,0,0,0-.3,1.87,3.9,3.9,0,0,0,.29,1.78,1.08,1.08,0,0,0,1,.53,1.37,1.37,0,0,0,.72-.18,2.54,2.54,0,0,0,.67-.63Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M333.4,116.27h-4.1l-.06,3a3.59,3.59,0,0,1,1-.63,2.87,2.87,0,0,1,1-.18,2.53,2.53,0,0,1,1.22.28,2.44,2.44,0,0,1,.86.8,3.91,3.91,0,0,1,.26.59,3.25,3.25,0,0,1,.18.7,7.22,7.22,0,0,1,.1.91c0,.34,0,.75,0,1.21s0,.93,0,1.3a6.49,6.49,0,0,1-.11,1,3.1,3.1,0,0,1-.22.76,4.07,4.07,0,0,1-.33.66,2.88,2.88,0,0,1-2.63,1.22,3,3,0,0,1-2.34-.9,3.93,3.93,0,0,1-.79-2.64v-.14a1.79,1.79,0,0,1,0-.23h1.9v.33c0,1.18.41,1.76,1.23,1.76a1.1,1.1,0,0,0,1.09-.69,2.24,2.24,0,0,0,.18-.78,14.24,14.24,0,0,0,.05-1.49,13.26,13.26,0,0,0-.06-1.47,3.47,3.47,0,0,0-.21-.87,1.19,1.19,0,0,0-.42-.49,1.22,1.22,0,0,0-1.35,0,2.73,2.73,0,0,0-.63.82h-1.76l.14-6.65h5.78Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M170.59,23.54V4.41h-6.88V0h18.78V4.41h-6.85V23.54Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M207.65,23.54V13.62H196.53v9.92h-5V0h5V9.25h11.12V0h5V23.54Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M223.15,23.54V0H239.8V4.41H228.16V9.35h11.4v4.41h-11.4v5.37H239.8v4.41Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M.59,93.78C-1.81,85.5,3.3,77.94,12,75.6c7.71-2.06,12.54,1.16,15.17,4.47-2.64,2.05-3.94,3.08-6.54,5.16A6.21,6.21,0,0,0,14,82.79,7,7,0,0,0,17.57,96.3a6.18,6.18,0,0,0,4.56-5.4c3.26.54,4.88.82,8.11,1.4-.74,4-3.33,9.21-10.74,11.19C11.1,105.74,3,102,.59,93.78Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M49.27,66.66c8.9-1.9,16.9,2.56,18.51,11S63.85,93.07,55.29,94.9,38.8,92.6,36.83,84.25,40.36,68.56,49.27,66.66ZM50.82,74a7,7,0,0,0,2.91,13.66A7,7,0,0,0,50.82,74Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M75.44,62c3.56-.63,5.35-.94,8.91-1.52C85.4,66.9,85.92,70.08,87,76.46c.44,2.64,2.18,4.51,5.69,4s4.55-2.85,4.15-5.5c-1-6.39-1.43-9.59-2.39-16,3.57-.53,5.36-.79,8.94-1.28.89,6.5,1.34,9.75,2.23,16.25,1,6.88-2.36,12.39-11.78,13.87S79.5,85,78.3,78.23C77.16,71.75,76.59,68.51,75.44,62Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M126.36,67.87c.64,5.95,1,8.93,1.61,14.89-3.41.37-5.11.56-8.51,1-1.32-11.09-2-16.63-3.32-27.71,3.64-.44,5.46-.65,9.1-1,4.66,5.16,7,7.75,11.46,13-.52-5.6-.79-8.4-1.31-14,3.54-.33,5.31-.49,8.85-.78.91,11.13,1.36,16.7,2.27,27.82-3.27.27-4.91.41-8.18.72C133.63,76.14,131.23,73.37,126.36,67.87Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M162.9,59.27c-3.11.18-4.66.28-7.77.49l-.5-7.35c9.81-.66,14.72-.92,24.54-1.26l.25,7.36c-3.09.11-4.64.17-7.74.31.37,8.21.56,12.32.93,20.53-3.42.15-5.12.24-8.54.43C163.61,71.58,163.37,67.48,162.9,59.27Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M201.74,69.67l-3.12,0c0,3.58,0,5.37.08,9-3.42,0-5.13,0-8.55.12-.23-11.16-.34-16.74-.57-27.9,6.25-.13,9.38-.16,15.64-.16,6.85,0,10.48,4.43,10.4,9.66a9,9,0,0,1-5.26,8.39c2,4,3,5.95,5,9.93-3.89,0-5.84-.07-9.73-.07C204.12,75,203.33,73.24,201.74,69.67Zm2.13-11.93c-2.15,0-3.22,0-5.36,0l.05,4.89,5.31,0a2.48,2.48,0,1,0,0-4.89Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M233.12,68.07c-4-6.89-6.1-10.32-10.33-17.15,4,.09,6,.15,10,.3,2,3.85,3,5.77,5,9.63,2.28-3.67,3.43-5.5,5.77-9.15,4,.21,6,.32,10,.58-4.79,6.43-7.13,9.67-11.73,16.18-.22,4.43-.33,6.64-.56,11.07-3.41-.17-5.12-.25-8.53-.38C232.87,74.72,233,72.5,233.12,68.07Z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M305.12,67.83c-3.53,6.63-5.26,10-8.66,16.63L292.68,84c-1.65-7.3-2.51-11-4.28-18.24-.79,7-1.19,10.5-2,17.5-3.4-.39-5.1-.57-8.51-.92,1.13-11.11,1.7-16.66,2.83-27.76,4.89.49,7.33.76,12.2,1.34,1.38,5.89,2.05,8.84,3.34,14.74,2.72-5.39,4.09-8.09,6.88-13.46,4.88.65,7.31,1,12.17,1.72-1.65,11-2.47,16.56-4.12,27.6-3.39-.5-5.09-.75-8.48-1.21Z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M341.25,88c-4.3-.83-6.45-1.22-10.75-2-.69,1.34-1,2-1.71,3.35-3.66-.64-5.5-.95-9.17-1.54q7.38-13,15.15-25.74c4.41.77,6.61,1.18,11,2q2.71,14.67,5,29.45c-3.65-.76-5.47-1.12-9.13-1.83Zm-7.32-8.51c2.58.46,3.86.7,6.44,1.19-.56-4.11-.85-6.17-1.44-10.28C336.91,74,335.91,75.83,333.93,79.47Z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M365.12,68.07c3.49.77,5.23,1.16,8.71,2-1.86,8-2.78,12-4.64,20,4.24,1,6.35,1.49,10.58,2.54L378,99.74c-7.53-1.86-11.3-2.75-18.86-4.41C361.53,84.43,362.73,79,365.12,68.07Z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M395.22,83c-3-.8-4.56-1.2-7.6-2,.73-2.86,1.09-4.29,1.82-7.14,9.59,2.44,14.37,3.75,23.9,6.52l-2,7.07c-3-.87-4.51-1.3-7.52-2.14-2.21,7.91-3.31,11.87-5.52,19.79-3.33-.93-5-1.38-8.32-2.27C392,94.87,393.1,90.9,395.22,83Z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M136.14,120.72c0-7,5.34-11.51,11.87-11.51a10.38,10.38,0,0,1,9.18,5l-3.91,2.13a6.4,6.4,0,0,0-5.27-2.9c-4.07,0-7,3.1-7,7.31s2.93,7.3,7,7.3a7.44,7.44,0,0,0,4.71-1.7v-2.67h-5.87v-4.13h10.6v8.53a12.28,12.28,0,0,1-9.44,4.17C141.48,132.22,136.14,127.72,136.14,120.72Z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M179.3,131.82l-4.37-7.9h-3.47v7.9h-4.74V109.58h10.41c4.64,0,7.5,3,7.5,7.17a6.43,6.43,0,0,1-4.9,6.6l5,8.47Zm.46-15.11a3,3,0,0,0-3.3-3h-5v6h5A3,3,0,0,0,179.76,116.71Z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M192.6,120.72c0-6.71,4.91-11.51,11.64-11.51a11.17,11.17,0,0,1,11.61,11.51c0,6.7-4.9,11.5-11.61,11.5S192.6,127.42,192.6,120.72Zm18.38,0c0-4.17-2.63-7.31-6.74-7.31s-6.77,3.14-6.77,7.31,2.64,7.3,6.77,7.3S211,124.85,211,120.72Z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M224.69,122.92V109.58h4.8v13.2c0,3.11,1.8,5.24,5.24,5.24s5.2-2.13,5.2-5.24v-13.2h4.84v13.34c0,5.5-3.27,9.3-10,9.3S224.69,128.42,224.69,122.92Z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  className: "cml-1",
  d: "M254.67,131.82V109.58h10.41c4.83,0,7.47,3.26,7.47,7.17s-2.67,7.13-7.47,7.13H259.4v7.94Zm13-15.07a3,3,0,0,0-3.3-3h-5v6h5A3,3,0,0,0,267.71,116.75Z"
});

var SvgCountryMaltLogo = function SvgCountryMaltLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 413.34 132.22",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCountryMaltLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CountryMaltLogo.b3ba62bb.svg";
export { ForwardRef as ReactComponent };